// The ecosystem a regulatory screen's link opens on: `?ecossistema=ofb|opin`. Without the key the
// screen opens on the first ecosystem the deployment serves, so the default never reaches the URL.
import { Option, Schema } from 'effect';
import { Ecosystem } from '@finnest/power-admin-contracts';

export const EcosystemSearch = Schema.Struct({
  ecossistema: Schema.optionalKey(Ecosystem),
});
export type EcosystemSearch = typeof EcosystemSearch.Type;

// The same key read as present or not: encoding `None` leaves it out of the URL.
const EcosystemUrl = Schema.Struct({
  ecossistema: Schema.OptionFromOptionalKey(Ecosystem),
});
const encodeUrl = Schema.encodeSync(EcosystemUrl);

/** The ecosystem the link asks for, if it names one. */
export const requestedEcosystemOf = (search: EcosystemSearch): Option.Option<Ecosystem> =>
  Option.fromUndefinedOr(search.ecossistema);

/** The search of a link asking for `requested`; `None` leaves the key out. */
export const ecosystemSearchOf = (requested: Option.Option<Ecosystem>): EcosystemSearch =>
  encodeUrl({ ecossistema: requested });
